import React from 'react';

const TermsOfService = ({ onBack }) => {
  return (
    <div className="home-container">
       <button className="back-btn" onClick={onBack} style={{marginBottom:'20px'}}>← Back</button>
       <div style={{background:'white', padding:'40px', borderRadius:'8px', border:'1px solid #ddd'}}>
          <h1>Terms of Service</h1>
          <p>Last Updated: June 26, 2026</p>
          <hr />

          <h3>1. Your Songs and Creative Work</h3>
          <p>Octavepad is a private songwriting workspace. You keep ownership of the lyrics, chords, tabs, riffs, notes, and other song material you create or store in your account. We do not claim ownership of your songs.</p>
          
          <h3>2. Private Storage</h3>
          <p>Your songbook is intended for your own account use. Octavepad stores and processes your content only so the app can provide features like editing, saving, chord display, tab display, and account syncing.</p>
          
          <h3>3. Plans and Limits</h3>
          <p>Free accounts may be limited to 5 songs and may not include chord creation. Premium and founder premium accounts include unlimited songs. Original members may include unlimited songs and chord creation. Plan features may change as the product develops.</p>
          
          <h3>4. Acceptable Use</h3>
          <p>Do not use Octavepad to harm the service, attempt unauthorized access, disrupt other systems, or store illegal material. We may suspend or terminate accounts that abuse the service or violate these terms.</p>

          <h3>5. Service Changes</h3>
          <p>Octavepad is actively developing. Features may be added, changed, paused, or removed over time. We will try to avoid disrupting your access to your own saved work.</p>

          <h3>6. Contact</h3>
          <p>If you run into a bug or need support, use the bug report form in the app so we can review the issue with your account context.</p>
       </div>
    </div>
  );
};

export default TermsOfService;
